import React, { useState } from "react";
import { useQuery } from "react-query";
import { toast } from "../../../../components/toastNotification";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import { getCarrierStateOfficeCodes } from "../../../../actions/CarrierAgreementMgmt/Reports";
import {
  ArrowDownCircleIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import { mainSelectedTab } from "../../atoms";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useHistory } from "react-router-dom";
import {
  officeFromReports,
  officeShowState,
  officeViewData,
} from "../../OfficeSettings/atoms/atoms";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import DownloadButton from "../../../../components/DownloadButton";
// import { CSVLink } from "react-csv";
// import { ArrowDownCircleIcon } from "@heroicons/react/24/solid";

export const CAMSReports = (viewFromReports = false) => {
  const [carrierStateOfficeCodesData, setCarrierStateOfficeCodesData] =
    useState([]);
  const [hideEntityEIN, setHideEntityEIN] = useState(true);
  const [hideLicenseNumber, setHideLicenseNumber] = useState(true);
  const [hideGlEntityName, setHideGlEntityName] = useState(true);
  const [hideGLNumber, setHideGLNumber] = useState(true);
  const [loading, setLoading] = useState(true);
  const [hideEntityName, setHideEntityName] = useState(true);
  const [filterText] = useState("");
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [exportedData, setExportedData] = useState([]);

  useQuery("CarrierStateOfficeCodes", getCarrierStateOfficeCodes, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      if (res) {
        //res);
        if (res.statusCode === 500 || res.statusCode === 400) {
          toast.fire("Server Error", "Cannot display data", "error");
        } else {
          setCarrierStateOfficeCodesData(res);
          setLoading(false);
        }
      } else {
        toast.fire("No Data:", "No available data to display.", "info");
      }
    },
  });

  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();

  const downloadCampsReport = () => {
    if (carrierStateOfficeCodesData) {
      setExportedData(
        carrierStateOfficeCodesData.map(({ tableData, ...res }) => res)
      );
    }
  };
  const csvReport = {
    filename: "CAMSReports_" + dateTimeToday + ".csv",
    data: exportedData ? exportedData : [],
  };

  const columns = [
    {
      title: "Carrier Name",
      field: "carrierName",
    },
    { title: "State", field: "state" },
    { title: "Agency", field: "agency" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  pathname: url,
                  officeCode: rowData?.officeCode,
                  action: "csopcreport",
                },
              });
              window.location.reload();
              let userTabs = [];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });

              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Office Code", field: "officeCode" },
    { title: "Producer Code", field: "producerCode" },
    { title: "Entity Name", field: "entityName", hidden: hideEntityName },
    { title: "Entity EIN", field: "entityEIN", hidden: hideEntityEIN },
    {
      title: "License Number",
      field: "licenseNumber",
      hidden: hideLicenseNumber,
    },
    {
      title: "GL Entity Name",
      field: "glEntityName",
      hidden: hideGlEntityName,
    },
    { title: "GL Number", field: "glNumber", hidden: hideGLNumber },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <RectangleStackIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading-tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Carrier Agreement Management
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Carrier State Office Producer Code Report
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {carrierStateOfficeCodesData?.length}
              </span>
            </div>
            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => {
                  downloadCampsReport();
                }}
              />
            </CSVLink>
          </div>
        </div>
        <div className="flex flex-row">
          <div className="items-center mx-4 pt-4 pb-2 flex">
            <div className="text-tertiary text-xs3 ">
              Display Additional Columns:
            </div>

            <div className="flex flex-row text-xs3 gap-x-4 gap-y-2 ml-2">
              <div className="flex items-center space-x-1 cursor-pointer ">
                <input
                  type="checkbox"
                  className="flex items-center space-x-1 cursor-pointer"
                  onClick={() => setHideEntityName(!hideEntityName)}
                />
                <label>Entity Name</label>
              </div>
              <div className="flex items-center space-x-1 cursor-pointer">
                <input
                  type="checkbox"
                  className="flex items-center space-x-1 cursor-pointer"
                  onClick={() => setHideEntityEIN(!hideEntityEIN)}
                />
                <label>Entity EIN</label>
              </div>
              <div className="flex items-center space-x-1 cursor-pointer">
                <input
                  type="checkbox"
                  className="flex items-center space-x-1 cursor-pointer"
                  onClick={() => setHideLicenseNumber(!hideLicenseNumber)}
                />
                <label>License Number</label>
              </div>
              <div className="flex items-center space-x-1 cursor-pointer">
                <input
                  type="checkbox"
                  className="flex items-center space-x-1 cursor-pointer"
                  onClick={() => setHideGlEntityName(!hideGlEntityName)}
                />
                <label>GL Entity Name</label>
              </div>
              <div className="flex items-center space-x-1 cursor-pointer ">
                <input
                  type="checkbox"
                  className="flex items-center space-x-1 cursor-pointer"
                  onClick={() => setHideGLNumber(!hideGLNumber)}
                />
                <label>GL Number</label>
              </div>
            </div>
          </div>
        </div>

        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={carrierStateOfficeCodesData}
            isLoading={loading}
            columns={columns}
            showTitle={false}
            title="Overriding Export Function Preview"
            fileName={"Carrier State Office Producer Code Report"}
            toolbarSearch={true}
            showToolbar={true}
          />
        </div>
      </div>
    </div>
  );
};

export default CAMSReports;
